(function () {
  if (window.__vpWinterRamp20260802) return;
  window.__vpWinterRamp20260802 = true;

  function isEnglish() {
    return location.pathname.indexOf('/en') === 0 || document.documentElement.lang === 'en';
  }

  function addSort() {
    if (!document.body || (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-search'))) return;
    if (document.querySelector('.vp-winter-sort')) return;
    var products = document.querySelector('.collection-products');
    if (!products || !products.parentNode) return;
    var en = isEnglish();
    var current = new URL(location.href).searchParams.get('sort_by') || '';
    var choices = [
      ['', en ? 'Featured' : 'Recomendados'],
      ['best-selling', en ? 'Best selling' : 'Más vendidos'],
      ['price-ascending', en ? 'Price: low to high' : 'Precio: menor a mayor'],
      ['price-descending', en ? 'Price: high to low' : 'Precio: mayor a menor'],
      ['created-descending', en ? 'Newest' : 'Novedades'],
      ['title-ascending', en ? 'Name: A–Z' : 'Nombre: A–Z']
    ];
    var bar = document.createElement('div');
    bar.className = 'vp-winter-sort';
    var label = document.createElement('label');
    label.htmlFor = 'vp-winter-sort-select';
    label.textContent = en ? 'Sort' : 'Ordenar';
    var select = document.createElement('select');
    select.id = 'vp-winter-sort-select';
    select.setAttribute('aria-label', label.textContent);
    choices.forEach(function (choice) {
      var option = document.createElement('option');
      option.value = choice[0];
      option.textContent = choice[1];
      option.selected = choice[0] === current;
      select.appendChild(option);
    });
    select.addEventListener('change', function () {
      var url = new URL(location.href);
      if (select.value) url.searchParams.set('sort_by', select.value);
      else url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      location.href = url.toString();
    });
    bar.appendChild(label);
    bar.appendChild(select);
    products.parentNode.insertBefore(bar, products);
  }

  function compactCatalog() {
    if (!document.body || (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-search'))) return;
    if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('.collection-products > .row > [class*="col-"]'), function (item) {
      item.style.setProperty('width', '50%', 'important');
      item.style.setProperty('max-width', '50%', 'important');
      item.style.setProperty('flex', '0 0 50%', 'important');
      item.style.setProperty('margin', '0', 'important');
      item.style.setProperty('padding-left', '6px', 'important');
      item.style.setProperty('padding-right', '6px', 'important');
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-js-product].product-collection'), function (card) {
      card.style.setProperty('width', '100%', 'important');
      card.style.setProperty('max-width', 'none', 'important');
      card.style.setProperty('height', '100%', 'important');
      card.style.setProperty('margin', '0', 'important');
      card.querySelectorAll('.product-collection__image,.product-collection__image-wrapper,.rimage').forEach(function (image) {
        image.style.setProperty('min-height', '0', 'important');
        image.style.setProperty('height', 'auto', 'important');
        image.style.setProperty('aspect-ratio', '1 / 1', 'important');
      });
      var content = card.querySelector('.product-collection__content');
      if (content) {
        content.style.setProperty('min-height', '168px', 'important');
        content.style.setProperty('padding', '12px 10px 11px', 'important');
      }
    });
  }

  function addProductConfidence() {
    if (location.pathname.indexOf('/products/') === -1 || document.querySelector('.vp-winter-buy-confidence')) return;
    var form = document.querySelector('.product-page-info form[action*="/cart/add"], form[action*="/cart/add"]');
    if (!form || !form.parentNode) return;
    var en = isEnglish();
    var note = document.createElement('div');
    note.className = 'vp-winter-buy-confidence';
    note.setAttribute('aria-label', en ? 'Purchase information' : 'Información de compra');
    note.innerHTML = '<span>' + (en ? 'Protected bottle packaging' : 'Embalaje protegido') + '</span>' +
      '<span>' + (en ? 'Secure payment' : 'Pago seguro') + '</span>' +
      '<a href="' + (en ? '/en/policies/shipping-policy' : '/policies/shipping-policy') + '">' + (en ? 'Shipping times and costs' : 'Plazos y gastos de envío') + '</a>';
    form.parentNode.insertBefore(note, form);
  }

  function addCartConfidence() {
    if (!/\/cart(?:\/|$)/.test(location.pathname)) return;
    var en = isEnglish();
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.parentElement && !node.parentElement.closest('script,style,noscript,textarea') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('Gastos de envío y descuentos calculado al momento de pagar') !== -1) {
        node.nodeValue = node.nodeValue.replace('Gastos de envío y descuentos calculado al momento de pagar', 'Gastos de envío y descuentos calculados al pagar');
      }
    }
    var existing = document.querySelector('.vp-winter-cart-confidence');
    if (existing && existing.offsetWidth && existing.offsetHeight) return;
    if (existing) existing.remove();
    var checkout = Array.prototype.find.call(document.querySelectorAll('[name="checkout"],a[href*="/checkout"],button[type="submit"]'), function (element) {
      return element.offsetWidth && element.offsetHeight;
    });
    if (!checkout || !checkout.parentNode) return;
    var note = document.createElement('div');
    note.className = 'vp-winter-cart-confidence';
    note.innerHTML = '<span>' + (en ? 'Protected bottle packaging' : 'Embalaje protegido') + '</span>' +
      '<span>' + (en ? 'Secure payment' : 'Pago seguro') + '</span>' +
      '<a href="' + (en ? '/en/policies/shipping-policy' : '/policies/shipping-policy') + '">' + (en ? 'Shipping information' : 'Información de envíos') + '</a>';
    checkout.parentNode.insertBefore(note, checkout);
  }

  function run() {
    addSort();
    compactCatalog();
    addProductConfidence();
    addCartConfidence();
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 700);
  setTimeout(compactCatalog, 1800);
  document.addEventListener('click', function (event) {
    var control = event.target && event.target.closest && event.target.closest('button,a');
    if (!control || !/cargar más|load more/i.test(control.textContent || '')) return;
    setTimeout(compactCatalog, 500);
    setTimeout(compactCatalog, 1400);
  });
})();
